module.exports = __webpack_public_path__ + "img/badge_color_spe-beta-v2.9d56fdc6.svg";